import { TemplateRef } from '@angular/core';
import { CertificadosService } from '../../../services/certificados.service';
import { MatDialog } from '@angular/material';
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
var PropiedadesComponent = /** @class */ (function () {
    //propiedades: { rol: string; id_direcc: string; folio: string; calle: string; calle_num: number; direccion_completa: string; direc_complemento: string; direc_compl_num: string; direc_anexo: string; direc_anexo_num: string; loteo: string; manzana: string; plano: string; ubicacion: string; recordId: string; };
    function PropiedadesComponent(_CertificadosService, dialog, _formService, spinner) {
        this._CertificadosService = _CertificadosService;
        this.dialog = dialog;
        this._formService = _formService;
        this.spinner = spinner;
        this.rows = [];
        this.direcciones = [];
        this.p = 1;
        this.isopen = false;
        this.rol = new FormControl('', [Validators.required]);
        this.dir = new FormControl('', [Validators.required]);
        this.num = new FormControl('', [Validators.required]);
        this.matcher = new FormService();
        if (!JSON.parse(localStorage.getItem("propiedades"))) {
            localStorage.setItem("propiedades", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("propiedades"));
        }
        this.invalidRol = true;
        this.propiedades = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', direc_anexo: '', direc_anexo_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', valido: '', recordId: '', checked: false };
    }
    PropiedadesComponent.prototype.getPropiedades_rol = function () {
        var _this = this;
        console.log("getpropiedades_rol");
        this.spinner.show();
        this._CertificadosService.getPropiedades(this.rol.value, undefined, undefined, undefined).subscribe(function (response) {
            console.log("get propiedades_rol response", response);
            if (response.direcciones) {
                _this.direcciones = response.direcciones;
                _this.dialog.open(_this.modalDirecciones);
                _this.spinner.hide();
                console.log("response.direcciones", response.direcciones);
            }
            else {
                if (response.message) {
                    _this.propiedades.rol = _this.rol.value ? _this.rol.value : '';
                    _this.dialog.open(_this.openModal);
                    _this.spinner.hide();
                }
                else {
                    _this.propiedades.rol = response.rol ? response.rol : '';
                    _this.propiedades.id_direcc = response.id_direcc ? response.id_direcc : '';
                    _this.propiedades.folio = response.folio ? response.folio : '';
                    _this.propiedades.calle = response.calle ? response.calle : '';
                    _this.propiedades.calle_num = response.calle_num ? response.calle_num : '';
                    _this.propiedades.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    _this.propiedades.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                    _this.propiedades.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                    _this.propiedades.direc_anexo = response.direc_anexo ? response.direc_anexo : '';
                    _this.propiedades.direc_anexo_num = response.direc_anexo_num ? response.direc_anexo_num : '';
                    _this.propiedades.loteo = response.loteo ? response.loteo : '';
                    _this.propiedades.manzana = response.manzana ? response.manzana : '';
                    _this.propiedades.plano = response.plano ? response.plano : '';
                    _this.propiedades.ubicacion = response.ubicacion ? response.ubicacion : '';
                    _this.propiedades.valido = response.valido ? response.valido : '';
                    _this.propiedades.recordId = response.recordId ? response.recordId : '';
                    _this.dialog.open(_this.openModal);
                    _this.spinner.hide();
                }
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    PropiedadesComponent.prototype.getPropiedades_por_rol = function (rol, id) {
        var _this = this;
        this.spinner.show();
        this._CertificadosService.getPropiedades(rol, id, undefined, undefined).subscribe(function (response) {
            console.log("propiedades_por_rol response", response);
            if (response.direcciones) {
                _this.direcciones = response.direcciones;
                _this.dialog.open(_this.modalDirecciones);
                _this.spinner.hide();
            }
            else {
                if (response.message) {
                    _this.propiedades.rol = _this.rol.value ? _this.rol.value : '';
                    _this.dialog.open(_this.openModalVerPorRol);
                    _this.spinner.hide();
                }
                else {
                    _this.propiedades.rol = response.rol ? response.rol : '';
                    _this.propiedades.id_direcc = response.id_direcc ? response.id_direcc : '';
                    _this.propiedades.folio = response.folio ? response.folio : '';
                    _this.propiedades.calle = response.calle ? response.calle : '';
                    _this.propiedades.calle_num = response.calle_num ? response.calle_num : '';
                    _this.propiedades.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    _this.propiedades.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                    _this.propiedades.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                    _this.propiedades.direc_anexo = response.direc_anexo ? response.direc_anexo : '';
                    _this.propiedades.direc_anexo_num = response.direc_anexo_num ? response.direc_anexo_num : '';
                    _this.propiedades.loteo = response.loteo ? response.loteo : '';
                    _this.propiedades.manzana = response.manzana ? response.manzana : '';
                    _this.propiedades.plano = response.plano ? response.plano : '';
                    _this.propiedades.ubicacion = response.ubicacion ? response.ubicacion : '';
                    _this.propiedades.valido = response.valido ? response.valido : '';
                    _this.propiedades.recordId = response.recordId ? response.recordId : '';
                    _this.dialog.open(_this.openModalVerPorRol);
                    _this.spinner.hide();
                }
            }
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    PropiedadesComponent.prototype.getPropiedades_dir = function () {
        var _this = this;
        this._CertificadosService.getPropiedades(undefined, this.dir.value, this.num.value).subscribe(function (response) {
            if (response.direcciones) {
                _this.direcciones = response.direcciones;
                _this.dialog.open(_this.modalDirecciones);
            }
            else {
                if (response.message) {
                    //this.propiedad.dir = dir ? dir : '';
                    // this.propiedad.num = num ? num : '';
                    _this.dialog.open(_this.openModal);
                }
                else {
                    _this.propiedades.rol = response.rol ? response.rol : '';
                    _this.propiedades.id_direcc = response.id_direcc ? response.id_direcc : '';
                    _this.propiedades.folio = response.folio ? response.folio : '';
                    _this.propiedades.calle = response.calle ? response.calle : '';
                    _this.propiedades.calle_num = response.calle_num ? response.calle_num : '';
                    _this.propiedades.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    _this.propiedades.direc_complemento = response.direc_complemento ? response.direc_complemento : '';
                    _this.propiedades.direc_compl_num = response.direc_compl_num ? response.direc_compl_num : '';
                    _this.propiedades.direc_anexo = response.direc_anexo ? response.direc_anexo : '';
                    _this.propiedades.direc_anexo_num = response.direc_anexo_num ? response.direc_anexo_num : '';
                    _this.propiedades.loteo = response.loteo ? response.loteo : '';
                    _this.propiedades.manzana = response.manzana ? response.manzana : '';
                    _this.propiedades.plano = response.plano ? response.plano : '';
                    _this.propiedades.ubicacion = response.ubicacion ? response.ubicacion : '';
                    _this.propiedades.valido = response.valido ? response.valido : '';
                    _this.propiedades.recordId = response.recordId ? response.recordId : '';
                    _this.dialog.open(_this.openModal);
                    _this.isopen = false;
                }
            }
        }, function (error) {
            console.log(error);
            _this.isopen = false;
        });
    };
    PropiedadesComponent.prototype.cleanData = function () {
        this.propiedades = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', direc_anexo: '', direc_anexo_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', valido: '', recordId: '' };
        this.rol.reset();
        this.num.reset();
        this.dir.reset();
    };
    PropiedadesComponent.prototype.savePropiedades = function () {
        $("#dir_modal").modal("hide");
        this.actualRow = localStorage.getItem("propiedades");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            rol: this.propiedades.rol,
            id_direcc: this.propiedades.id_direcc,
            folio: this.propiedades.folio,
            calle: this.propiedades.calle,
            calle_num: this.propiedades.calle_num,
            direccion_completa: this.propiedades.direccion_completa,
            direc_complemento: this.propiedades.direc_complemento,
            direc_compl_num: this.propiedades.direc_compl_num,
            direc_anexo: this.propiedades.direc_anexo,
            direc_anexo_num: this.propiedades.direc_anexo_num,
            loteo: this.propiedades.loteo,
            manzana: this.propiedades.manzana,
            plano: this.propiedades.plano,
            ubicacion: this.propiedades.ubicacion,
            valido: this.propiedades.valido,
            recordId: this.propiedades.recordId
        });
        localStorage.setItem("propiedades", JSON.stringify(this.rows));
        this.propiedades = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', direc_anexo: '', direc_anexo_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', valido: '', recordId: '' };
        this.num.reset();
        this.rol.reset();
        this.dir.reset();
        this.dialog.closeAll();
    };
    PropiedadesComponent.prototype.savePropiedadesMulti = function (direccion) {
        console.log("savepropiedadesMulti direccion", direccion);
        $("#dir_modal2").modal("hide");
        this.actualRow = localStorage.getItem("propiedades");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            rol: direccion.rol ? direccion.rol : '',
            id_direcc: direccion.id_direcc ? direccion.id_direcc : '',
            folio: direccion.folio ? direccion.folio : '',
            calle: direccion.calle ? direccion.calle : '',
            calle_num: direccion.calle_num ? direccion.calle_num : '',
            direccion_completa: direccion.direccion_completa ? direccion.direccion_completa : '',
            direc_complemento: direccion.direc_complemento ? direccion.direc_complemento : '',
            direc_compl_num: direccion.direc_compl_num ? direccion.direc_compl_num : '',
            direc_anexo: direccion.direc_anexo ? direccion.direc_anexo : '',
            direc_anexo_num: direccion.direc_anexo_num ? direccion.direc_anexo_num : '',
            loteo: direccion.loteo ? direccion.loteo : '',
            manzana: direccion.manzana ? direccion.manzana : '',
            plano: direccion.plano ? direccion.plano : '',
            ubicacion: direccion.ubicacion ? direccion.ubicacion : '',
            valido: direccion.valido ? direccion.valido : '',
            recordId: direccion.recordId ? direccion.recordId : ''
        });
        localStorage.setItem("propiedades", JSON.stringify(this.rows));
        console.log("savepropiedadesmulti this.rows", this.rows);
        this.propiedades = { rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', direc_anexo: '', direc_anexo_num: '', loteo: '', manzana: '', plano: '', ubicacion: '', valido: '', recordId: '' };
        this.rol.reset();
        this.num.reset();
        this.dir.reset();
        this.dialog.closeAll();
    };
    PropiedadesComponent.prototype.deletePropiedades = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("propiedades", JSON.stringify(this.rows));
            }
        }
    };
    return PropiedadesComponent;
}());
export { PropiedadesComponent };
